// extracted by mini-css-extract-plugin
module.exports = {"playlist":"PlaylistPage_playlist__3cesH","fab":"PlaylistPage_fab__2YEcO"};